import { useMutation, useQueryClient } from "react-query";
import InitApi from "api/InitApi";
import useTokenStore from "store/tokenStore";

export default function useSyncCurrencyRates() {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();
	return useMutation(
		async () => {
			const api = await InitApi({ accessToken });
			const response = await api.post("/admin/currencies/sync-rates");
			return response.data;
		},
		{
			// Refresh both public and admin catalogues, including partial imports.
			onSuccess: () => queryClient.invalidateQueries(["currencies"]),
		},
	);
}
